import { Action } from '@ngrx/store';
import * as models from '../../domain/models';

export const LOAD = '[Fleet Ramen Regions] Load';
export const LOAD_SUCCESS = '[Fleet Ramen Regions] Load Success';
export const LOAD_FAIL = '[Fleet Ramen Regions] Load Fail';

export class LoadAction implements Action {
  readonly type = LOAD;
}

export class LoadSuccessPayload {
  entities: Array<models.RmnRegion>;
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;
  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction;
